// extracted by mini-css-extract-plugin
export var card = "productList-module--card--2cd9d";
export var meta = "productList-module--meta--e6d3b";
export var msg = "productList-module--msg--74810";
export var productname = "productList-module--productname--e6626";
export var warningMessage = "productList-module--warningMessage--0192a";